// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5122 ? "f037622c" : chunkId) + "." + {"568":"055ba7cd01711cf6","3559":"485627b5e4fd2cbc","5122":"fccd99f74b194278","6720":"36d262efd060ae79","8611":"00a69b1f2d300fe1","9122":"9fc048835f759136"}[chunkId] + ".js";
};